/* eslint no-underscore-dangle: "off" */ import React from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { motion } from "framer-motion";
import { animations } from "./animations";
export default function LoadingBullets(param) {
    var className = param.className;
    var bulletCx = twMerge("mx-2 w-4 h-4 rounded-full bg-fg-base/20");
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge("flex items-center justify-center", className)
    }, /*#__PURE__*/ React.createElement(motion.span, {
        className: bulletCx,
        animate: animations._320_3_ellipse_2
    }), /*#__PURE__*/ React.createElement(motion.span, {
        className: bulletCx,
        animate: animations._320_4_ellipse_3
    }), /*#__PURE__*/ React.createElement(motion.span, {
        className: bulletCx,
        animate: animations._320_6_ellipse_4
    }));
}

//# sourceMappingURL=LoadingBullets.js.map